import { type ComponentProps, lazy, Suspense } from "react";

const Surface = lazy(() =>
	import("~/common/article/writing-surface").then((module) => ({ default: module.WritingField })),
);
export function WritingField(props: {
	value: string;
	onChange: (value: string) => void;
	label: string;
	disabled?: boolean;
	plain?: boolean;
	article?: boolean;
}) {
	return (
		<Suspense fallback={<p className="hint">{props.label}</p>}>
			<Surface {...props} />
		</Suspense>
	);
}

const Sheet = lazy(() => import("~/common/article/article-sheet").then((module) => ({ default: module.ArticleSheet })));
/** The article surface for a title and a markdown body; see `article-sheet`. */
export function ArticleSheet(props: ComponentProps<typeof Sheet>) {
	return (
		<Suspense fallback={<p className="hint">{props.body.label}</p>}>
			<Sheet {...props} />
		</Suspense>
	);
}
